<template>
    <div class="prime-section">
        <div class="container">
            <div class="content-wrapper">
                <!-- Left Side - Image -->
                <div class="image-container">
                    <img src="/wp-content/uploads/2024/02/lp-png.png" alt="Liquidity Provider" class="main-image">
                </div>

                <!-- Right Side - Content -->
                <div class="text-container">
                    <h1 class="main-title">Trade Safely & Easily</h1>
                    <p class="subtitle">Secure Experience with our liquidity provider partner.</p>

                    <div class="divider"></div>

                    <!-- Logos Container -->
                    <div class="logos-container">
                        <img src="/wp-content/uploads/2024/02/isprime.svg" alt="IS Prime" class="partner-logo">
                        <img src="/wp-content/uploads/2024/02/broctagon.svg" alt="Broctagon Prime" class="partner-logo">
                        <img src="/wp-content/uploads/2024/02/gbe.svg" alt="GBE Prime" class="partner-logo">
                    </div>

                    <!-- CTA Button -->
                    <a href="/signup" class="cta-button">
                        Start to Trade
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrimeSection'
}
</script>

<style scoped>
.prime-section {
    background-image: linear-gradient(135deg, #3A2A00 33%, var(--e-global-color-primary) 91%);
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

.prime-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 20% 50%, rgba(212, 175, 55, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(212, 175, 55, 0.05) 0%, transparent 50%);
    pointer-events: none;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.content-wrapper {
    display: grid;
    grid-template-columns: 45% 55%;
    gap: 60px;
    align-items: center;
}

/* Left Side - Image */
.image-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    display: block;
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3));
}

/* Right Side - Content */
.text-container {
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.main-title {
    font-family: "Fira Sans", Sans-serif;
    font-size: 56px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 10px 0;
    color: #ffffff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.subtitle {
    font-size: 20px;
    font-weight: 400;
    color: #e0e0e0;
    margin: 0 0 30px 0;
    line-height: 1.6;
}

.divider {
    width: 100%;
    max-width: 600px;
    height: 2px;
    background: linear-gradient(90deg, #D4AF37 0%, transparent 100%);
    margin-bottom: 20px;
}

/* Logos Container */
.logos-container {
    display: flex;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
    margin-bottom: 40px;
}

.partner-logo {
    height: 50px;
    width: auto;
    object-fit: contain;
    opacity: 0.9;
    transition: all 0.3s ease;
    filter: brightness(1.1);
}

.partner-logo:hover {
    opacity: 1;
    transform: scale(1.05);
    filter: brightness(1.3);
}

/* CTA Button */
.cta-button {
    background: linear-gradient(135deg, #c7a014 0%, #a5840c 100%);
    color: #ffff;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 32px;
    border-radius: 3px;
    text-decoration: none;
    display: inline-block;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(212, 175, 55, 0.3);
    letter-spacing: 0.5px;
}

.cta-button:hover {
    transform: translateY(0px);
    box-shadow: 0 12px 35px rgba(212, 175, 55, 0.5);
    background: linear-gradient(135deg, #927a1a 0%, #8d7118 100%);
}

.cta-button:active {
    transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 1024px) {
    .content-wrapper {
        grid-template-columns: 1fr;
        gap: 50px;
    }

    .image-container {
        order: 2;
    }

    .text-container {
        order: 1;
        align-items: center;
        text-align: center;
    }

    .main-title {
        font-size: 48px;
    }

    .subtitle {
        font-size: 18px;
    }

    .divider {
        margin-left: auto;
        margin-right: auto;
    }

    .logos-container {
        justify-content: center;
    }
}

@media (max-width: 768px) {
    .prime-section {
        padding: 70px 0;
    }

    .main-title {
        font-size: 40px;
    }

    .subtitle {
        font-size: 16px;
    }

    .logos-container {
        gap: 30px;
    }

    .partner-logo {
        height: 40px;
    }

    .cta-button {
        padding: 16px 50px;
        font-size: 16px;
        width: 100%;
        max-width: 400px;
        text-align: center;
    }

    .main-image {
        max-width: 400px;
    }
}

@media (max-width: 480px) {
    .prime-section {
        padding: 50px 0;
    }

    .container {
        padding: 0 15px;
    }

    .content-wrapper {
        gap: 40px;
    }

    .main-title {
        font-size: 32px;
    }

    .subtitle {
        font-size: 15px;
    }

    .logos-container {
        gap: 20px;
        flex-direction: column;
        align-items: center;
    }

    .partner-logo {
        height: 35px;
    }

    .cta-button {
        padding: 14px 40px;
        font-size: 15px;
        width: 100%;
    }

    .main-image {
        max-width: 320px;
    }
}

@media (max-width: 360px) {
    .main-title {
        font-size: 28px;
    }

    .subtitle {
        font-size: 14px;
    }

    .partner-logo {
        height: 30px;
    }

    .main-image {
        max-width: 280px;
    }
}
</style>
